import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';

export const createLoadingAction = createActionCreator(constant.ListLoading, loading => loading); // 流加载
export const createMessageListAction = createActionCreator(constant.TaskMessageListGET, messageList => messageList); // 通知列表
export const createMessagePageAction = createActionCreator(
    constant.TaskMessageListPage,
    messageListPage => messageListPage,
); // 查询结果分页数据
export const createPassAction = createActionCreator(constant.TaskMessageGet, messagePass => messagePass); //查阅消息
// 获取通知列表
export const getMessageList = params => {
    const str = paramsEncode(params).replace(/\&/, '?');
    const path = Urls.TaskMessage.messageList + str;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(path);
            dispatch(createMessagePageAction(response));
            dispatch(createMessageListAction(response.list));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

// 查阅消息
export const passedMessage = value => {
    const path = Urls.TaskMessage.viewed + '/?_id=' + value;
    console.log(path);
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(path);
            dispatch(createPassAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};



// WEBPACK FOOTER //
// ./pages/user/taskMessage/actions.js